import { Link } from "gatsby";
import ecssdviewlog from "assets/img/docs/gettingStarted/container-insights/ecssd-view-log.png";
import ecssdviewmertric from "assets/img/docs/gettingStarted/container-insights/ecssd-view-metric.png";
import * as React from 'react';
export default {
  Link,
  ecssdviewlog,
  ecssdviewmertric,
  React
};